import { useEffect, useId, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { primaryNav } from '../../content/site'
import { Button } from '../ui/Button'
import { ThemeToggle } from '../ui/ThemeToggle'
import { BrandLogo } from '../../shared/BrandLogo'

export function SiteHeader() {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  const menuId = useId()

  useEffect(() => {
    setOpen(false)
  }, [location.pathname])

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
    }
  }, [open])

  return (
    <header className="pp-header">
      <div className="pp-container pp-header__inner">
        <BrandLogo className="pp-brand" tone="light" to="/" />

        <nav className="pp-nav" aria-label="Primary">
          {primaryNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="pp-header__actions">
          <ThemeToggle />
          <Button to="/login" variant="secondary" size="sm" className="pp-header__login">
            Login
          </Button>
          <Button to="/register" size="sm" className="pp-header__register">
            Register
          </Button>
          <button
            type="button"
            className="pp-menu-btn"
            aria-expanded={open}
            aria-controls={menuId}
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={() => setOpen((value) => !value)}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              {open ? (
                <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              ) : (
                <path d="M4 7h16M4 12h16M4 17h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {open ? (
        <div className="pp-mobile-nav" id={menuId}>
          <nav aria-label="Mobile">
            {primaryNav.map((item) => (
              <NavLink key={item.to} to={item.to} end={item.to === '/'}>
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="pp-mobile-nav__cta">
            <Button to="/login" variant="secondary">
              Login
            </Button>
            <Button to="/register">Register</Button>
          </div>
        </div>
      ) : null}
    </header>
  )
}
